/** @format */

import {ReactElement} from 'react';

import {Typography} from '@mui/material';

import {TooltipContentContainer} from './styles';

export const TooltipContent = (): ReactElement => {
  return (
    <TooltipContentContainer>
      <Typography sx={{mb: 1}}>
        Модуль считает прогноз по расходу средств в проекте на конец периода, указанного в
        медиаплане.
      </Typography>
      <Typography sx={{mb: 1}}>
        Одновременно строится три прогноза: минимальный, средний и максимальный.
      </Typography>
      <Typography>
        В начале отчетного периода прогноз строится на скользящей в 7 дней в прошлое.
      </Typography>
      <Typography>
        Если с начала периода прошло 7 и более календарных дней, считаем прогноз от начала периода
        до текущей даты.
      </Typography>
    </TooltipContentContainer>
  );
};
